import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import groupActions from '../../redux/groups/actions';
import GroupList from '../../components/GroupList';
import SidebarContainer from '../SidebarContainer';
import './Groups.scss';

function Groups({ groups, actions, history }) {
  useEffect(() => {
    actions.groupsRequest();
  }, [actions]);

  return (
    <SidebarContainer title="Groups" openSubMenu="Client Management">
      <div className="groups-table">
        <GroupList
          list={groups?.groups}
          history={history}
          deleteGroupRequest={actions.deleteGroupRequest}
        />
      </div>
    </SidebarContainer>
  );
}

Groups.propTypes = {
  groups: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object,
};

const mapStateToProps = ({ groups }) => ({ groups });

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...groupActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
